import { useContext } from 'react';

import { RuntimeContext } from './Runtime.context';

export const useRuntimeContext = () => {
    const context = useContext(RuntimeContext);
    if (!context) {
        throw new Error('useRuntimeContext must be used within a RuntimeProvider');
    }
    return context;
};
